import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {TICKET_STATE_NAME} from '../constant';

interface TicketSliceState {
  receivedFreeTicket: {
    [key: /* seriesId */ number]: true;
  };
  /**
   * 스마트푸시를 위해 사용된 티켓 uid 를 open_page 에 포함해서 전달하기 위함
   */
  usedTicketUid: {
    [key: /* productId */ number]: string;
  };
}

export const ticketSlice = createSlice({
  name: TICKET_STATE_NAME,
  initialState: {
    receivedFreeTicket: {},
    usedTicketUid: {},
  } as TicketSliceState,
  reducers: {
    freeTicketReceived: (
      state,
      action: PayloadAction<{seriesId: number}>
    ): void => {
      state.receivedFreeTicket[action.payload.seriesId] = true;
    },
    putUsedTicketUid: (
      state,
      action: PayloadAction<{productId: number; ticketUid: string}>
    ): void => {
      state.usedTicketUid[action.payload.productId] = action.payload.ticketUid;
    },
  },
});

export const {freeTicketReceived, putUsedTicketUid} = ticketSlice.actions;
